var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { useChatAuthenticationTracking } from '../../analytics/hooks';
export var ChatAnalyticsContext = React.createContext({
    setIsExistingCustomer: function () { return false; },
    setAuthViaSmartChat: function () { return false; },
    authViaSmartChat: false,
});
export var CustomerExistenceEnum;
(function (CustomerExistenceEnum) {
    CustomerExistenceEnum["REGISTERED"] = "REGISTERED";
    CustomerExistenceEnum["NEW"] = "NEW";
    CustomerExistenceEnum["UNKNOWN"] = "UNKNOWN";
})(CustomerExistenceEnum || (CustomerExistenceEnum = {}));
export var ChatAnalyticsProvider = function (_a) {
    var children = _a.children;
    var _b = React.useState(CustomerExistenceEnum.UNKNOWN), customerExistenceStatus = _b[0], setCustomerExistenceStatus = _b[1];
    var _c = React.useState(false), hasAuthedViaChat = _c[0], setChatAuthed = _c[1];
    // tracks when user is authenticated on chat
    useChatAuthenticationTracking(customerExistenceStatus, hasAuthedViaChat);
    return (React.createElement(ChatAnalyticsContext.Provider, { value: {
            setIsExistingCustomer: function (isExist) {
                return setCustomerExistenceStatus(isExist ? CustomerExistenceEnum.REGISTERED : CustomerExistenceEnum.NEW);
            },
            setAuthViaSmartChat: function (isAuth) { return setChatAuthed(isAuth); },
            authViaSmartChat: hasAuthedViaChat,
        } }, children));
};
export var useChatAuthAnalytics = function () {
    var analyticsState = React.useContext(ChatAnalyticsContext);
    if (!analyticsState) {
        throw new Error('Please setup <ChatAnalyticsContext /> as a parent component, before using useAnalytics().');
    }
    return analyticsState;
};
export var withChatAnalytics = function (Component) {
    return function (props) {
        return (React.createElement(ChatAnalyticsProvider, null,
            React.createElement(Component, __assign({}, props))));
    };
};
//# sourceMappingURL=index.js.map